var React = require('react');

function CalloutIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.134 0.779052C11.5189 0.112385 12.4812 0.112386 12.8661 0.779053L23.8223 19.7558C24.2072 20.4225 23.7261 21.2558 22.9563 21.2558H1.04381C0.274009 21.2558 -0.207114 20.4225 0.177786 19.7558L11.134 0.779052Z","fill":"current"}));
}

CalloutIconInline.defaultProps = {"width":"24","height":"22","viewBox":"0 0 24 22","fill":"none"};

module.exports = CalloutIconInline;

CalloutIconInline.default = CalloutIconInline;
